<template>
  <div>
    <v-toolbar dense
               fixed>
      <v-btn router
             flat
             to="/viewfreight"
             class="teal--text darken-2">Kangaruu</v-btn>
      <v-spacer></v-spacer>

      <v-btn class="c"
             small
             router
             flat
             icon
             v-on:click="logout">
        <v-icon>exit_to_app</v-icon>
      </v-btn>

      <v-btn small
             flat
             icon
             router
             color="teal"
             @click.native="showHelp = true">
        <v-icon>help</v-icon>
      </v-btn>

    </v-toolbar>

    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step step="1"
                        :complete="e1 > 1"
                        editable>Equipment</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2"
                        :complete="e1 > 2"
                        editable>Pickup</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3"
                        :complete="e1 > 3"
                        editable>Destination</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4"
                        :complete="e1 > 4"
                        editable>Freight</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="5"
                        :complete="e1 > 5"
                        editable>Notes</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>

        <v-stepper-content step="1">
          <v-radio-group v-model="truck"
                         row>
            <v-radio label="OTR"
                     value="OTR"></v-radio>
            <v-radio label="LTL"
                     value="LTL"></v-radio>
            <v-radio label="RAIL"
                     value="RAIL"></v-radio>
            <v-radio label="FLAT BED"
                     value="FLAT BED"></v-radio>
          </v-radio-group>

          <v-layout row>
            <v-btn fab
                   dark
                   small
                   color="teal"
                   v-on:click.native="addEquipment">
              <v-icon dark>check</v-icon>
            </v-btn>
          </v-layout>
        </v-stepper-content>

        <v-stepper-content step="2">
          <pickup v-on:cargo="newCargo"
                  v-on:city="getCity"
                  v-on:nextStep="e1++"
                  :deliveryDate="pickupDate"
                  pickupType='Pickup'></pickup>
        </v-stepper-content>

        <v-stepper-content step="3">
          <pickup v-on:cargo="newCargo"
                  v-on:city="getCity"
                  v-on:nextStep="e1++"
                  :deliveryDate="deliveryDate"
                  pickupType='Delivery'></pickup>
          <google-map :pickupDate="pickupDate"
                      :deliveryDate="deliveryDate"
                      :pickupAddresses="pickupAddresses"
                      :deliveryAddresses="deliveryAddresses"
                      v-on:newDate="addDate">
          </google-map>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-text-field ref="freight"
                        v-model="freight"
                        label="Freight"
                        id="freight"></v-text-field>
          <v-layout row>
            <v-btn fab
                   dark
                   small
                   color="blue"
                   @click.native="addFreight(false)">
              <v-icon dark>add</v-icon>
            </v-btn>
            <v-btn fab
                   dark
                   small
                   color="teal"
                   v-on:click.native="addFreight(true)">
              <v-icon dark>check</v-icon>
            </v-btn>
          </v-layout>
        </v-stepper-content>

        <v-stepper-content step="5">
          <v-text-field ref="options"
                        v-model="options"
                        label="Notes"
                        id="options"></v-text-field>
          <v-layout row>
            <v-btn fab
                   dark
                   small
                   color="blue"
                   @click.native="addOptions(false)">
              <v-icon dark>add</v-icon>
            </v-btn>
            <v-btn fab
                   dark
                   small
                   color="teal"
                   v-on:click.native="showBrokers=true">
              <v-icon dark>check</v-icon>
            </v-btn>
          </v-layout>
        </v-stepper-content>

      </v-stepper-items>
    </v-stepper>

    <v-container fluid
                 class="pa-0">
      <v-layout row
                wrap>
        <template v-for="(chip, index) in chips">

          <v-chip close
                  @input="remove(chip)"
                  outline
                  label
                  :key="index"
                  v-bind:style="{ color: chipColor(chip) }">{{chip}}
          </v-chip>
        </template>
      </v-layout>
    </v-container>

    <v-dialog v-model="showBrokers"
              max-width="400">
      <v-card>
        <v-card-title>Broker List</v-card-title>
        <v-divider></v-divider>
        <v-list v-for="(broker, key) in user.brokers"
                :key="key">
          <v-list-tile>
            <v-list-tile-title>
              <broker-name :brokerID="key"></broker-name>
            </v-list-tile-title>
            <v-list-tile-action>
              <v-checkbox :value="key"
                          v-model="brokers"></v-checkbox>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider></v-divider>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1"
                 flat
                 @click.native="addOptions(true)">Send</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showHelp">
      <v-card>
        <help></help>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey"
                 flat
                 outline
                 @click.native="showHelp = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>

</template>

<script>
import db from './fireBaseInit'
import Pickup from './pickup'
import googleMap from './GoogleMap'
import Firebase from 'firebase'
import moment from 'moment'
import brokerName from './BrokerName'
import help from '@/components/Help'

export default {

  components: { Pickup, googleMap, brokerName, help },

  name: 'newfreight',
  data () {
    return {
      address: '',
      pickupAddresses: [],
      deliveryAddresses: [],
      pickupDate: null,
      deliveryDate: null,
      e1: 1,
      truck: 'OTR',
      options: [],
      c1: 'teal',
      chips: [],
      date: null,
      menu: null,
      freight: null,
      user: {},
      brokers: [],
      showBrokers: false,
      showHelp: false,
      city: ''
    }
  },
  firestore () {
    return {
    }
  },
  computed: {
  },
  mounted: function () {
    this.$bind('user', db.collection('users').doc(Firebase.auth().currentUser.uid))
      .then((doc) => {
        var moment = require('moment')
        var date = moment().add(1, 'days')
        this.pickupDate = moment(date).format('YYYY-MM-DD')
        this.deliveryDate = moment(date).format('YYYY-MM-DD')
        for (var brokerKey in this.user.brokers) {
          this.brokers.push(brokerKey)
        }
      })
  },
  methods: {
    getAddressData: function (addressData, placeResultData, id) {
      this.address = addressData
      if (this.address) {
        this.chips.push(this.address.locality + ', ' + this.address.postal_code)
      }
    },
    logout: function () {
      Firebase.auth().signOut().then(() => {
        this.$router.replace('/')
      })
    },
    chipColor: function (chip) {
      if (chip) {
        switch (chip.substring(0, chip.indexOf(':'))) {
          case 'Pickup': return 'teal'
          case 'PickupDate': return 'teal'
          case 'Freight': return 'red'
          case 'Options': return 'orange'
          case 'Equipment': return 'black'
          case 'Delivery': return 'blue'
          case 'DeliveryDate': return 'blue'
          case 'Miles': return 'purple'
          default:
            return 'black'
        }
      } else {
        return 'black'
      }
    },
    remove (item) {
      this.chips.splice(this.chips.indexOf(item), 1)
      this.chips = [...this.chips]
      // Todo remove from addresses if devivery
    },
    getCity (city) {
      this.city = city
    },
    newCargo (cargo) {
      if (cargo) {
        this.chips.push(cargo)
        let value = cargo.substring(cargo.indexOf(':') + 2, cargo.length)
        switch (cargo.substring(0, cargo.indexOf(':'))) {
          case 'PickupDate':
            this.pickupDate = value
            this.deliveryDate = this.pickupDate
            break
          case 'DeliveryDate': this.deliveryDate = value
            break
          case 'Pickup':
            this.pickupAddresses.push(value)
            break
          case 'Delivery': this.deliveryAddresses.push(value)
            break
        }
      }
    },
    addDate (newDate) {
      if (typeof newDate !== 'undefined' && newDate) {
        console.log(newDate)

        for (let i = 0; i < this.chips.length; i++) {
          var str = this.chips[i]
          var n = str.indexOf(':')
          var key = str.substring(0, n)
          if (key === 'Pickup') {
            this.remove(i)
          }
          if (key === 'Delivery') {
            this.remove(i)
          }
        }
        for (let i = 0; i < newDate.length; i++) {
          this.newCargo('Delivery: ' + newDate[i][0])
        }
        var miles = newDate[newDate.length - 1][1]
        this.chips.push('Miles: ' + miles.substring(0, miles.length - 2))
        var seconds = newDate[newDate.length - 1][3]
        const oneSecond = 0.000277778
        var hours = seconds * oneSecond
        var days = (hours / 11)
        var moment = require('moment')
        var date = moment(this.pickupDate).add(days, 'days')
        this.deliveryDate = moment(date).format('YYYY-MM-DD')
      }
    },
    addEquipment () {
      if (typeof this.truck !== 'undefined' && this.truck) {
        this.chips.push('Equipment: ' + this.truck)
      } else {
        this.chips.push('Equipment: ' + 'None')
      }
      this.e1++
    },
    addFreight (move) {
      if (typeof this.freight !== 'undefined' && this.freight) {
        this.chips.push('Freight: ' + this.freight)
      }
      if (move) {
        this.e1++
      } else {
        this.freight = ''
        this.$refs.freight.focus()
      }
    },
    addOptions (move) {
      if (typeof this.options !== 'undefined' && this.options) {
        this.chips.push('Options: ' + this.options)
      } else {
        this.chips.push('Options: ' + 'None')
      }
      if (move) {
        this.showBrokers = false
        this.updateFireStore(this.chips)
        this.$router.push('/viewfreight')
      } else {
        this.options = ''
        this.$refs.options.focus()
      }
    },
    guid () {
      function _p8 (s) {
        var p = (Math.random().toString(16) + '00000000').substr(2, 6)
        return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p
      }
      return _p8()
    },
    updateFireStore (chips) {
      let n = ''
      let str = ''
      let key = ''
      let val = ''
      let shipment = {}
      let pickup = []
      let freight = []
      let delivery = []
      let options = []
      let brokerList = {}
      this.chips.sort()
      shipment['Reference'] = this.guid()

      for (let i = 0; i < this.chips.length; i++) {
        str = this.chips[i]
        n = str.indexOf(':')
        key = str.substring(0, n)
        val = str.substring(n + 2, str.length)
        console.log(key)
        if (key === 'Pickup') {
          pickup.push(val)
        } else if (key === 'Freight') {
          freight.push(val)
        } else if (key === 'Delivery') {
          delivery.push(val)
        } else if (key === 'Options') {
          options.push(val)
        } else {
          shipment[key] = val
        }
        shipment['Pickup'] = pickup
        shipment['Freight'] = freight
        shipment['Delivery'] = delivery
        shipment['Options'] = options
        shipment['Shipper'] = Firebase.auth().currentUser.uid
        shipment['isActive'] = true
        shipment['created'] = moment().unix()
        if (this.city) {
          shipment['City'] = this.city
        } else {
          shipment['City'] = 'Unknown'
        }
      }
      for (let i = 0; i < this.brokers.length; i++) {
        brokerList[this.brokers[i]] = true
      }
      console.log(brokerList)
      shipment['brokers'] = brokerList
      shipment['newMessages'] = brokerList
      // db.collection('freight').add({ shipment }) <--makes on object
      db.collection('freight').add(shipment).then((snap) => {
        // start the conversation record
        var con = {}
        con['created'] = moment().unix()
        con['shipper'] = Firebase.auth().currentUser.uid
        db.collection('conversations').doc(snap.id).set(con)
        // Send all brokers a message
        var msg = {}
        var quote = {}
        msg['message'] = 'Please Quote this Shipment'
        msg['sender'] = Firebase.auth().currentUser.uid
        msg['created'] = moment().unix()
        for (var brokerKey in brokerList) {
          // console.log(snap.id + 'freight')
          db.collection('conversations').doc(snap.id).collection('brokers').doc(brokerKey).collection('messages').add(msg)
          quote['quote'] = '$0'
          quote['status'] = 'New'
          quote['selected'] = false
          quote['isActive'] = true
          quote['shipper'] = Firebase.auth().currentUser.uid
          db.collection('conversations').doc(snap.id).collection('brokers').doc(brokerKey).set(quote)
        }
        // ok Lets send some texts and push
        var sms = {}
        var push = {}
        for (brokerKey in brokerList) {
          db.collection('users').doc(brokerKey).get().then((snap) => {
            console.log(snap.data().sendSMS)
            if (snap.data().sendSMS) {
              sms['phoneNumber'] = snap.data().mobile
              sms['company'] = this.user.company
              sms['messageType'] = 'Freight Quote'
              console.log(sms)
              db.collection('sms').add(sms)
            }
            if (snap.data().sendPush) {
              push['sendTo'] = snap.id
              db.collection('push').add(push)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewFreight.vue